import {apiHelper,PromiseHandler} from "../redux/apiHelper"
const deleteBlogById=(id)=>PromiseHandler(apiHelper('post',`/api/admin/blog/delete/${id}`))
const getBlogs=()=>PromiseHandler(apiHelper('get','/api/admin/blog/get'))
const getBlogById=(id)=>PromiseHandler(apiHelper('get',`/api/admin/blog/get/${id}`))
const updateBlogById=(id,data)=>PromiseHandler(apiHelper('post',`/api/admin/blog/update/${id}`,data))
const addBlog=(data)=>PromiseHandler(apiHelper('post','/api/admin/blog/create',data))
export {deleteBlogById,getBlogs,getBlogById,updateBlogById,addBlog}
